module.exports = __webpack_public_path__ + "img/h5_game_detail_surfing10_classic.3f2b2c18.jpg";